function getQueryValue(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return null;
}

function getGeoip() {
  const geo = new URLSearchParams(window.location.search).get('geo');

  // One-time disable (current tab/session behavior)
  if (geo === 'off') {
    sessionStorage.setItem('geo', 'false');
  }

  // Permanent disable for this browser on this domain
  if (geo === 'off-perm') {
    localStorage.setItem('geo', 'false');
    sessionStorage.setItem('geo', 'false');
  }

  // Re-enable geo redirects (clear both temporary + permanent flags)
  if (geo === 'on') {
    localStorage.removeItem('geo');
    sessionStorage.removeItem('geo');
  }

  // Permanent flag wins, then session flag
  if (localStorage.getItem('geo') === 'false') return false;
  if (sessionStorage.getItem('geo') === 'false') return false;

  return true;
}
function setCountry() {
  return new Promise((resolve) => {
    const sessionCountry = sessionStorage.getItem('country');

    if (sessionCountry) resolve(sessionCountry);
    else {
      fetch('https://country.geoip.workers.dev/')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text();
        })
        .then((country) => {
          sessionStorage.setItem('country', country);
          resolve(country);
        })
        .catch((error) => {
          console.error(error);
          resolve('US');
        });
    }
  });
}

function getCountry() {
  const geoip = getGeoip();
  if (!geoip) return;

  const DOMAINS = {
    default: 'rahua.com',
    EU: 'rahua.eu',
    GB: 'rahua.uk',
  };

  const EU_COUNTRIES = new Set([
    'BE','DE','LU','DK','IT','CZ','PL','AT','FI','IE','PT','ES','SE','BG','EE',
    'LV','LT','RO','SK','HR','GR','HU','SI','NL','RU','UA','FR'
  ]);

  const domainForCountry = (code) => {
    if (code === 'GB') return DOMAINS.GB;
    if (EU_COUNTRIES.has(code)) return DOMAINS.EU;
    return DOMAINS.default;
  };

  const normalizeHost = (h) => h.replace(/^www\./i, '');

  setCountry()
    .then((countryRaw) => {
      const country = (countryRaw || '').toUpperCase();
      const currentHost = normalizeHost(window.location.hostname);

      // Force redirect from rahua.fr to rahua.eu
      if (currentHost === 'rahua.fr') {
        const url = new URL(window.location.href);
        url.hostname = DOMAINS.EU;
        window.location.replace(url.toString());
        return;
      }

      const targetHost = domainForCountry(country);
      if (currentHost === targetHost) return;

      const key = `geo-redirect:${currentHost}->${targetHost}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');

      const url = new URL(window.location.href);
      url.hostname = targetHost;
      window.location.replace(url.toString());
    })
    .catch(console.error);
}

getCountry();
